import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getItem } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME } from 'src/reducers/clients/payrollRulesGroups';

import AllowanceRow from './AllowanceRow';
import styles from './AllowancesTable.scss';

const AllowancesTable = ({ allowances, handleDeleteRow, payrollRuleGroup }) => {
  const { t } = useTranslation();
  const isSemiMonthlyPayment = payrollRuleGroup?.paymentCount === 'twice';

  return (
    <div className="l-overflow-scroll">
      <table className="m-table-list">
        <colgroup>
          <col width={200} />
          <col width={500} />
          <col width={100} />
        </colgroup>
        <thead>
          <tr>
            <th>{t('features.ClientBonusAllowances.components.BonusAllowancesTable.item_name')}</th>
            <th>{t('features.ClientBonusAllowances.components.BonusAllowancesTable.amount')}</th>
            <th className={styles.action} />
          </tr>
        </thead>
        <tbody>
          {(!allowances || allowances.length === 0) && (
            <tr>
              <td colSpan={3}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
            </tr>
          )}
          {allowances &&
            allowances.map(allowance => (
              <AllowanceRow
                key={allowance.id}
                allowance={allowance}
                handleDeleteRow={handleDeleteRow}
                isSemiMonthly={isSemiMonthlyPayment}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  payrollRuleGroup: getItem(REDUCER_NAME, state)
});

export default connect(mapStateToProps)(AllowancesTable);
